import { render, staticRenderFns } from "./referral-fees.vue?vue&type=template&id=138d987a"
import script from "./referral-fees.vue?vue&type=script&lang=js"
export * from "./referral-fees.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports